import styled from "styled-components";
import { getBreakpoint } from "../../../../../themes/common";
import { theme } from "../../theme/toyotaTheme";

export const Text = styled.div.attrs(() => ({
    className: "t-milli-text",
}))`
    margin: ${theme.space[1]}px 0;
    color: ${theme.colors.grey7};
    @media ${getBreakpoint("up", "lg")} {
        max-width: 263px;
    }
`;
